/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoSquareIcon20Light = forwardRef('InfoSquareIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6a.75.75 0 1 1-1.5 0A.75.75 0 0 1 10 6Z" }),
        React.createElement("path", { d: "M8.5 8.011a.5.5 0 0 0 0 1H9v2.999H8a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1h-1V8.761a.75.75 0 0 0-.75-.75H8.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5.5A3.5 3.5 0 0 1 5.5 2h8A3.5 3.5 0 0 1 17 5.5v8a3.5 3.5 0 0 1-3.5 3.5h-8A3.5 3.5 0 0 1 2 13.5v-8ZM5.5 3A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 13.5 3h-8Z" })));
});
